import styled from '@emotion/styled';

export const SpinnerImg = styled.img`
  height: ${(props) => props.$height || 40}px;
  width: ${(props) => props.$width || 40}px;
`;
